import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function PinDeselectedIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 56 56"
        {...props}
      >
        <path d="M2.5 55.5a2.004 2.004 0 0 1-1.42-3.42l14.24-14.24-9.92-9.92v-2.83l4.47-4.47 1.25-.58 11.65-.98 6.83-6.84 1-7.22.57-1.15L34.53.49h2.83L55.5 18.64v2.83l-3.36 3.36-1.43.59-8.17-.05-6.65 6.65.08 12.68-.59 1.43-4.47 4.47h-2.83l-9.92-9.92L3.92 54.91c-.39.39-.9.59-1.42.59m17.08-19.08 9.92 9.92 2.46-2.47-.08-12.68.59-1.43 7.83-7.83 1.43-.59 8.17.05 1.35-1.35-15.3-15.3-1.46 1.46-.98 7.21-.57 1.15-7.84 7.84-1.25.58-11.65.98-2.54 2.54z" />
      </svg>
    </Icon>
  )
}
export default PinDeselectedIcon
